export const USER_TENANT_PROVIDER_LABELS = {
	loadingErrorTitle: 'Account Loading Error'
};
